/**
 * Toast Notification Component
 * 
 * Simple toast untuk notifications (camera keyframe, errors, success)
 */

import React, { useEffect } from 'react'

export default function Toast({ toast, onClose }) {
  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => {
        onClose()
      }, 3000) // Auto-close after 3 seconds

      return () => clearTimeout(timer)
    }
  }, [toast, onClose])

  if (!toast) return null

  const getBackgroundColor = () => {
    switch (toast.type) {
      case 'success':
        return '#10b981'
      case 'delete':
      case 'error':
        return '#ef4444'
      case 'info':
      default:
        return '#3b82f6'
    }
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: '80px',
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '12px 20px',
        background: getBackgroundColor(),
        color: '#fff',
        borderRadius: '8px',
        fontSize: '13px',
        fontWeight: 600,
        zIndex: 9999,
        animation: 'toastSlideIn 0.3s ease-out forwards',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
      }}
    >
      {toast.message}
    </div>
  )
}

